import React,{Fragment} from 'react';
import {
  Card, CardBody, Button
} from 'reactstrap';
import ReactTable from "react-table";
import { withTranslation } from 'react-i18next';
import { Spinner } from 'reactstrap';



class LandingPageTable extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      landingPageData : this.props.landingPageList,
      isLoaded : this.props.isLoaded
    }
  }
  componentWillReceiveProps(props){
    console.log(props);
    this.setState({
      isLoaded: props.isLoaded,
      landingPageData: props.landingPageList
    })
  }
  render(){
    const { t, i18n } = this.props;
    return (
      <CardBody>
      {this.state.isLoaded ? <ReactTable
      columns={[
        {
          Header: t("landing_page.name"),
          accessor : 'name'
        },
        {
          Header: t("landing_page.last_modified_date"),
          accessor : 'modified_date',
        },
        {
          /* TODO: Replace inline style class with CSS class */
          Header: "Actions",
          Cell: ({row}) => (
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <Button className="mb-2 mr-2 btn-icon btn-shadow" size="md" color="success" onClick={() => this.props.onEditOrCopy(row._original)}>
                <i className="lnr-pencil btn-icon-wrapper mx-auto"> </i>
              </Button>
              <Button className="mb-2 mr-2 btn-icon btn-shadow" size="md" color="success" onClick={() => this.props.onEditOrCopy(row._original, true)}>
                <i className="pe-7s-copy-file btn-icon-wrapper mx-auto"> </i>
              </Button>
              <Button className="mb-2 mr-2 btn-icon btn-shadow" size="md" color="success" onClick={() => this.props.onDelete(row)}>
                <i className="pe-7s-trash btn-icon-wrapper mx-auto"> </i>
              </Button>
            </div>
          )
        }]}
      data={this.state.landingPageData}
      showPageSizeOptions={false}
      defaultPageSize={10}
      pageSize={this.state.landingPageData.length}
      className="-striped -highlight"
      /> : <div><Spinner color="primary" /> Data is loading!!!</div>}
    </CardBody>)
  }
}

export default withTranslation()(LandingPageTable);
